import { AcompanhamentoPuericulturaCardQuery } from 'graphql/types.generated'
import { isEmpty } from 'util/checks'

import { convertMChatRfQueryToViewModel } from '../../objetivo/puericultura/mchat-rf/converter-mChatRf'
import { UltimosMchatRfQueryModel } from '../../objetivo/puericultura/mchat-rf/model-mChatRf'
import { initialValueMarcosDesenvolvimento } from '../../objetivo/puericultura/model'
import { medicaoPerimetroCefalicoMaisRecente } from '../../objetivo/puericultura/util'
import { AcompanhamentoPuericulturaModel, initialValueAvaliacaoAcompanhamento } from './model'
import { vacinacaoEmDiaMaisRecente } from './util/vacinacaoEmDiaMaisRecente'

export const convertAcompanhamentoPuericulturaToModel = (
  queryResult: AcompanhamentoPuericulturaCardQuery,
  ultimosMchats: UltimosMchatRfQueryModel,
  cidadaoDataNascimento: string
): AcompanhamentoPuericulturaModel =>
  !isEmpty(queryResult) && {
    ...queryResult,
    alteracoesFenotipicas: {
      alteracoesFenotipicas: initialValueAvaliacaoAcompanhamento(queryResult.alteracoesFenotipicas),
    },
    fatoresRisco: { fatoresRisco: initialValueAvaliacaoAcompanhamento(queryResult.fatoresRisco) },
    marcosDesenvolvimento: initialValueMarcosDesenvolvimento(
      queryResult.marcosDesenvolvimento,
      queryResult.ultimoAtendimentoPuericultura?.dataInicio,
      cidadaoDataNascimento
    ),
    medicaoAnteriorPerimetroCefalico: medicaoPerimetroCefalicoMaisRecente(queryResult.medicoesAnteriores, {
      dataMedicao: cidadaoDataNascimento,
      valorPerimetroCefalico: +queryResult.antecedente?.perimetroCefalico,
    }),
    vacinacaoEmDia: vacinacaoEmDiaMaisRecente(queryResult.medicoesAnteriores, cidadaoDataNascimento),
    registrosMChat: queryResult.registrosMChat,
    mChatRf: convertMChatRfQueryToViewModel(ultimosMchats.ultimoMChatR, ultimosMchats.ultimoMChatRf),
  }
